import PocketBase from 'pocketbase';

const POCKETBASE_URL =
  import.meta.env.VITE_POCKETBASE_URL || window.location.origin;

export const pb = new PocketBase(POCKETBASE_URL);

// Disable auto-cancellation for React Query compatibility
pb.autoCancellation(false);

// Dev-mode banner: make it loud which PB instance the local frontend is hitting,
// and remind that backend changes (migrations, hooks/*.pb.js) require a deploy
// when the URL is not a local PocketBase.
if (import.meta.env.DEV) {
  const isLocal = /^https?:\/\/(localhost|127\.0\.0\.1)(:|\/|$)/.test(
    POCKETBASE_URL
  );
  const style = 'font-weight:bold;padding:2px 6px;border-radius:3px;';
  if (isLocal) {
    console.info(
      `%c[PB] local → ${POCKETBASE_URL}`,
      `${style}background:#5efea8;color:#0d0d0d;`
    );
  } else {
    console.warn(
      `%c[PB] REMOTE → ${POCKETBASE_URL}`,
      `${style}background:#fedb5e;color:#0d0d0d;`
    );
    console.warn(
      '[PB] Backend changes (pocketbase/migrations, pocketbase/hooks) will NOT take effect on localhost — they only run on the deployed PB. Deploy via the feature → develop → staging → main flow to see them.'
    );
  }
}

/** Get current authenticated user ID (throws if not authenticated) */
export function getCurrentUserId(): string {
  const user = pb.authStore.model;
  if (!user) {
    throw new Error('Not authenticated');
  }
  return user.id;
}
